import { ChevronLeft } from "@mui/icons-material";
import { Box, Button, colors, TextField } from "@mui/material";
import { useMobileContext } from "context/mobile/mobileContext";
import { useUserContext } from "context/data/userContext";
import { Link, useNavigate } from "react-router-dom";
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import { DateTimePicker } from "@mui/lab";
import ProductPreview from "components/ProductPreview/ProductPreview";
import { useEffect, useState, useMemo } from "react";
import { onPrint } from "hooks/onPrint";
import { useIntl } from "react-intl";
import { SingleItemCart } from "components/Cart/SingleItemCart";

export function PreviewPage() {
  const { brand, country, cart, dateTime, setDateTime, removeItem, pic } = useMobileContext();
  const { user } = useUserContext();
  const intl = useIntl();
  const navigate = useNavigate();
  const [cardItemId, setCardItemId] = useState<string | undefined>();
  const [isPrinting, setIsPrinting] = useState(false);
  const currentStore = useMemo(() => { return (window.mapp as any)?.userInfo?.currentStore }, []);

  useEffect(() => {
    if (cart.length === 0) {
      navigate('..');
    }
  }, [cart, navigate]);


  return (
    <>
      <Box>
        <>
        <Link to="../">
          <Button
            sx={{ color: 'black', fontSize: 18, textTransform: 'capitalize' }}
            startIcon={<ChevronLeft fontSize={'large'} />}>
            {intl.formatMessage({ id: 'mobile.button.print.labelInfo' })}
          </Button>
        </Link>
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <DateTimePicker
              renderInput={(props) => <TextField {...props} sx={{ width: '100%', marginTop: '16px', marginBottom: '32px' }} />}
              value={dateTime}
              onChange={(newValue) => {
                setDateTime(newValue);
              }}
            />
          </LocalizationProvider>
        </>
        {cart.map((product, index) => (
          <Box sx={{
            borderTop: index !== 0 ? `1px solid ${colors.grey[200]}` : '0px'
          }}>
            <ProductPreview
              {...product}
              dateTime={dateTime || new Date()}
              onRemove={removeItem}
              onEdit={() => {
                setCardItemId(product.id);
              }}
            />
          </Box>
        ))}
      </Box>
      <Box sx={{ flex: 1 }}></Box>
      <Box sx={{ display: 'flex' }}>
        <Box sx={{ marginTop: '60px' }} />
        <Box sx={{ bottom: 0, left: 0, right: 0, position: 'fixed', display: 'flex', padding: '16px' }}>
          <Button
            variant="contained"
            sx={{ flex: 1 }}
            disabled={isPrinting}
            onClick={async () => {
              setIsPrinting(true);
              await onPrint({ cart, intl, dateTime, brand, country, pic, user, currentStore });
              navigate('../success');
            }}>
            {intl.formatMessage({ id: 'mobile.button.print.title' })}
          </Button>
        </Box>
      </Box>
      <SingleItemCart cardItemId={cardItemId} onClose={() => setCardItemId(undefined)}/>
    </>
  );
}
